<div class="flex justify-end! gap-3 mt-4 w-full">
    @if (terceiro) {
        <div class="w-full sm:flex-1 sm:max-w-30">
            <app-button
                (click)="clickTerceiro()"
                variant="secondary"
                [fullWidth]="true"
            >
                {{ labelTerceiro }}
            </app-button>
        </div>
    }

    <div class="flex flex-col sm:flex-row justify-end gap-3 w-full">
        <div class="w-full sm:flex-1 sm:max-w-30">
            <app-button
                (click)="clickCancelar()"
                variant="danger"
                [fullWidth]="true"
            >
                {{ labelCancelar }}
            </app-button>
        </div>

        <div class="w-full sm:flex-1 sm:max-w-30">
            <app-button (click)="clickConfirmar()" [fullWidth]="true">
                {{ labelConfirmar }}
            </app-button>
        </div>
    </div>
</div>
